
import Router from 'vue-router';

const constantRouterMap = [
  { path: '/Home', component: () => import('@/views/Home'), hidden: true },
  { path: '/Code', component: () => import('@/views/Code'), hidden: true },
  { path: '/Image', component: () => import('@/views/Image'), hidden: true },
  { path: '/annunciate', component: () => import('@/views/annunciate'), hidden: true },
  { path: '/anonymity', component: () => import('@/views/anonymity'), hidden: true },
  { path: '/signature', component: () => import('@/views/signature'), hidden: true },
  { path: '/announcement', component: () => import('@/views/announcement'), hidden: true },
  { path: '/question', component: () => import('@/views/question'), hidden: true },
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404.vue'), hidden: true },
  // { path: '/pdf', component: () => import('@/views/Pdf/index'), hidden: true }, // 文件打印
];
const router = new Router({
  routes: constantRouterMap
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router
// import Vue from 'vue'
// import VueRouter from 'vue-router'

// Vue.use(VueRouter)

// const routes = [
//   {
//     path: '/',
//     redirect: '/Home'
//   },
//   {
//     path: '/Home',
//     component: () => import('@/views/Home')
//   },
//   {
//     path: '/Code',
//     component: () => import('@/views/Code')
//   },
//   {
//     path: '/Image',
//     component: () => import('@/views/Image')
//   },
//   {
//     path: '/login',
//     component: () => import('@/views/login/index')
//   }
// ]

// const router = new VueRouter({
//   routes
// })

// export default router



// WEBPACK FOOTER //
// ./src/router/index.js